var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import MD from 'markdown-it';
import { normalizeWhitespace } from '../utility/normalizeWhitespace';
import onHasCompletion from '../utility/onHasCompletion';
import commonKeys from '../utility/commonKeys';
import { importCodeMirror } from '../utility/importCodeMirror';
var md = new MD();
var AUTO_COMPLETE_AFTER_KEY = /^[a-zA-Z0-9_@(]$/;
var QueryEditor = (function (_super) {
    __extends(QueryEditor, _super);
    function QueryEditor(props) {
        var _this = _super.call(this, props) || this;
        _this.editor = null;
        _this.ignoreChangeEvent = false;
        _this._node = null;
        _this.addonModules = function () { return [
            import('codemirror/addon/comment/comment'),
            import('codemirror/addon/search/search'),
            import('codemirror-graphql/hint'),
            import('codemirror-graphql/lint'),
            import('codemirror-graphql/info'),
            import('codemirror-graphql/jump'),
            import('codemirror-graphql/mode'),
        ]; };
        _this._onKeyUp = function (_cm, event) {
            if (AUTO_COMPLETE_AFTER_KEY.test(event.key) && _this.editor) {
                _this.editor.execCommand('autocomplete');
            }
        };
        _this._onEdit = function () {
            if (!_this.ignoreChangeEvent && _this.editor) {
                _this.cachedValue = _this.editor.getValue();
                if (_this.props.onEdit) {
                    _this.props.onEdit(_this.cachedValue);
                }
            }
        };
        _this._onHasCompletion = function (cm, data) {
            onHasCompletion(cm, data, _this.props.onHintInformationRender);
        };
        _this.cachedValue = props.value || '';
        return _this;
    }
    QueryEditor.prototype.componentDidMount = function () {
        var _this = this;
        this.initializeEditor()
            .then(function (editor) {
            if (editor) {
                editor.on('change', _this._onEdit);
                editor.on('keyup', _this._onKeyUp);
                editor.on('hasCompletion', _this._onHasCompletion);
                editor.on('beforeChange', _this._onBeforeChange);
            }
        })
            .catch(console.error);
    };
    QueryEditor.prototype.componentDidUpdate = function (prevProps) {
        this.ignoreChangeEvent = true;
        var signalChange = false;
        if (this.props.schema !== prevProps.schema && this.editor) {
            this.editor.options.lint.schema = this.props.schema;
            this.editor.options.hintOptions.schema = this.props.schema;
            this.editor.options.info.schema = this.props.schema;
            this.editor.options.jump.schema = this.props.schema;
            signalChange = true;
        }
        if (this.props.externalFragments !== prevProps.externalFragments &&
            this.editor) {
            this.editor.options.lint.externalFragments = this.props.externalFragments;
            this.editor.options.hintOptions.externalFragments = this.props.externalFragments;
            signalChange = true;
        }
        if (signalChange) {
            this.CodeMirror.signal(this.editor, 'change', this.editor);
        }
        if (this.props.value !== prevProps.value &&
            this.props.value !== this.cachedValue &&
            this.editor) {
            this.cachedValue = this.props.value;
            this.editor.setValue(this.props.value);
        }
        this.ignoreChangeEvent = false;
    };
    QueryEditor.prototype.componentWillUnmount = function () {
        if (this.editor) {
            this.editor.off('change', this._onEdit);
            this.editor.off('keyup', this._onKeyUp);
            this.editor.off('hasCompletion', this._onHasCompletion);
        }
    };
    QueryEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement("section", { className: "query-editor", "aria-label": "Query Editor", ref: function (node) {
                _this._node = node;
            } }));
    };
    QueryEditor.prototype.initializeEditor = function () {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function () {
            var CodeMirror, _e, editor;
            var _this = this;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        _e = this;
                        return [4, importCodeMirror(this.addonModules())];
                    case 1:
                        CodeMirror = (_e.CodeMirror = _f.sent());
                        editor = (this.editor = CodeMirror(this._node, {
                            value: (_a = this.props.value) !== null && _a !== void 0 ? _a : '',
                            lineNumbers: true,
                            tabSize: 2,
                            foldGutter: {
                                minFoldSize: 4,
                            },
                            mode: 'graphql',
                            theme: this.props.editorTheme || 'graphiql',
                            keyMap: 'sublime',
                            autoCloseBrackets: true,
                            matchBrackets: true,
                            showCursorWhenSelecting: true,
                            readOnly: this.props.readOnly ? 'nocursor' : false,
                            lint: {
                                schema: this.props.schema,
                                validationRules: (_b = this.props.validationRules) !== null && _b !== void 0 ? _b : null,
                                externalFragments: (_c = this.props) === null || _c === void 0 ? void 0 : _c.externalFragments,
                            },
                            hintOptions: {
                                schema: this.props.schema,
                                closeOnUnfocus: false,
                                completeSingle: false,
                                container: this._node,
                                externalFragments: (_d = this.props) === null || _d === void 0 ? void 0 : _d.externalFragments,
                            },
                            info: {
                                schema: this.props.schema,
                                renderDescription: function (text) { return md.render(text); },
                                onClick: function (reference) {
                                    return _this.props.onClickReference && _this.props.onClickReference(reference);
                                },
                            },
                            jump: {
                                schema: this.props.schema,
                                onClick: function (reference) {
                                    return _this.props.onClickReference && _this.props.onClickReference(reference);
                                },
                            },
                            gutters: ['CodeMirror-linenumbers', 'CodeMirror-foldgutter'],
                            extraKeys: __assign(__assign({ 'Cmd-Space': function () {
                                    return editor.showHint({ completeSingle: true, container: _this._node });
                                }, 'Ctrl-Space': function () {
                                    return editor.showHint({ completeSingle: true, container: _this._node });
                                }, 'Alt-Space': function () {
                                    return editor.showHint({ completeSingle: true, container: _this._node });
                                }, 'Shift-Space': function () {
                                    return editor.showHint({ completeSingle: true, container: _this._node });
                                }, 'Shift-Alt-Space': function () {
                                    return editor.showHint({ completeSingle: true, container: _this._node });
                                }, 'Cmd-Enter': function () {
                                    if (_this.props.onRunQuery) {
                                        _this.props.onRunQuery();
                                    }
                                }, 'Ctrl-Enter': function () {
                                    if (_this.props.onRunQuery) {
                                        _this.props.onRunQuery();
                                    }
                                }, 'Shift-Ctrl-C': function () {
                                    if (_this.props.onCopyQuery) {
                                        _this.props.onCopyQuery();
                                    }
                                }, 'Shift-Ctrl-P': function () {
                                    if (_this.props.onPrettifyQuery) {
                                        _this.props.onPrettifyQuery();
                                    }
                                }, 'Shift-Ctrl-F': function () {
                                    if (_this.props.onPrettifyQuery) {
                                        _this.props.onPrettifyQuery();
                                    }
                                }, 'Shift-Ctrl-M': function () {
                                    if (_this.props.onMergeQuery) {
                                        _this.props.onMergeQuery();
                                    }
                                } }, commonKeys), { 'Cmd-S': function () {
                                    if (_this.props.onRunQuery) {
                                    }
                                }, 'Ctrl-S': function () {
                                    if (_this.props.onRunQuery) {
                                    }
                                } }),
                        }));
                        return [2, editor];
                }
            });
        });
    };
    QueryEditor.prototype.getCodeMirror = function () {
        return this.editor;
    };
    QueryEditor.prototype.getClientHeight = function () {
        return this._node && this._node.clientHeight;
    };
    QueryEditor.prototype._onBeforeChange = function (_instance, change) {
        if (change.origin === 'paste') {
            var text = change.text.map(normalizeWhitespace);
            change.update(change.from, change.to, text);
        }
    };
    return QueryEditor;
}(React.Component));
export { QueryEditor };
//# sourceMappingURL=QueryEditor.js.map